import { createSlice } from '@reduxjs/toolkit'

export const CompanyStore = createSlice({
  name: 'CompanyStore',
  initialState: {
    allCompany: [],
    companySame: []
  },
  reducers: {
    setCompanyInfo: (state: any, actions: any) => {
      state.allCompany = actions?.payload
    },
    setCompanySame: (state: any, actions: any) => {
      state.companySame = [...actions?.payload]
    }
  }
})

// Action creators are generated for each case reducer function
export const { setCompanyInfo, setCompanySame } = CompanyStore.actions

export default CompanyStore.reducer